import {
  BanknoteIcon,
  CheckCircleIcon,
  ClockIcon,
  ReceiptIcon,
} from "lucide-react";
import type { ExpensesSummaryDTO } from "../api/client";
import { formatExpenseAmount } from "../lib/expense-format";
import { ExpenseStatCard } from "./ExpenseStatCard";

export type ExpenseSummaryStatusFilter =
  | "all"
  | "submitted"
  | "approved"
  | "paid";

type ExpenseSummaryCardsProps = {
  summary: ExpensesSummaryDTO | undefined;
  isLoading: boolean;
  statusFilter: ExpenseSummaryStatusFilter;
  onStatusFilterChange: (status: ExpenseSummaryStatusFilter) => void;
};

export function ExpenseSummaryCards({
  summary,
  isLoading,
  statusFilter,
  onStatusFilterChange,
}: ExpenseSummaryCardsProps) {
  const totalCount = summary?.totalCount ?? 0;
  const paidItemCount = (summary?.paidCount ?? 0) + (summary?.closedCount ?? 0);

  const toggleStatus = (status: ExpenseSummaryStatusFilter) => {
    onStatusFilterChange(
      statusFilter === status && status !== "all" ? "all" : status,
    );
  };

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <ExpenseStatCard
        title="ຈຳນວນລາຍການ"
        value={totalCount.toLocaleString("lo-LA")}
        meta={
          !isLoading && summary
            ? formatExpenseAmount(summary.totalAmount)
            : undefined
        }
        isLoading={isLoading}
        icon={ReceiptIcon}
        tone="default"
        active={statusFilter === "all"}
        onClick={() => onStatusFilterChange("all")}
      />

      <ExpenseStatCard
        title="ລໍຖ້າອະນຸມັດ"
        value={(summary?.submittedCount ?? 0).toLocaleString("lo-LA")}
        meta={
          !isLoading && summary
            ? formatExpenseAmount(summary.submittedAmount)
            : undefined
        }
        isLoading={isLoading}
        icon={ClockIcon}
        tone="pending"
        active={statusFilter === "submitted"}
        onClick={() => toggleStatus("submitted")}
      />

      <ExpenseStatCard
        title="ອະນຸມັດລໍຖ້າຈ່າຍ"
        value={(summary?.approvedCount ?? 0).toLocaleString("lo-LA")}
        meta={
          !isLoading && summary
            ? formatExpenseAmount(summary.approvedAmount)
            : undefined
        }
        isLoading={isLoading}
        icon={CheckCircleIcon}
        tone="approved"
        active={statusFilter === "approved"}
        onClick={() => toggleStatus("approved")}
      />

      <ExpenseStatCard
        title="ຈ່າຍແລ້ວ"
        value={paidItemCount.toLocaleString("lo-LA")}
        meta={
          !isLoading && summary
            ? formatExpenseAmount(summary.paidAmount)
            : undefined
        }
        isLoading={isLoading}
        icon={BanknoteIcon}
        tone="paid"
        active={statusFilter === "paid"}
        onClick={() => toggleStatus("paid")}
      />
    </div>
  );
}
